<template>
    <div class="minisite-video-container" :style="getVideoStyle">
        <div ref="renderVideo" class="cv-mb-4 cv-w-full cv-h-auto" style="width: 100%; height: 100%"></div>
    </div>
</template>

<script>
    import { render, setConfig } from "@custouch-open/resource-video"

    import componentMinIn from "./component.mixin"
    import { collect, ElementType } from "../../service/site"
    import { getOriginOpenId, getUtm } from "@/utils/preflight"
    import { isPreviewEnv } from "@/utils/previewEnv"
    import { isTrustedParentIframe } from "@/utils/trustedParentIframe"

    export default {
        name: "BasicVideo",
        inject: {
            minisiteAccess: { default: () => ({ skipAccess: false }) }
        },
        mixins: [componentMinIn],
        components: {},
        props: {
            videoTitleStyle: {},
            videoStyle: {}
        },
        data() {
            return {
                videoSource: "",
                instance: null
            }
        },
        computed: {
            // getVideo() {
            //     return {
            //         backgroundVideo: 'url("' + this.data.videoSrc + '")',
            //         backgroundSize: 'contain'
            //     }
            // }
        },
        mounted() {
            this.renderVideo()
        },
        methods: {
            renderVideo() {
                setConfig({ appId: this._appId })

                const { videoSrc, poster, title } = this.data
                this.instance = render(this.$refs.renderVideo, {
                    source: videoSrc,
                    poster: poster,
                    allowSame: true,
                    skipAccess: this.minisiteAccess.skipAccess,
                    aspectRatio: "16:9",
                    play: () =>
                        collect("MINISITE_SYSTEM_CLICK_VIDEO", {
                            s_elementType: ElementType.video,
                            s_videoName: title,
                            s_videoUrl: videoSrc
                        }),
                    events: {
                        videoview: (video) => {
                            if (["play", "pause", "ended"].includes(video.event)) {
                                this.handleVideoEvent(video)
                            }
                        }
                    }
                })
            },
            handleVideoEvent({ name, source, event, duration, currentTime }) {
                if (window.cw && !isPreviewEnv() && !isTrustedParentIframe()) {
                    window.cw("action", "videoview", {
                        originOpenId: getOriginOpenId(),
                        ...getUtm(),
                        title: this._pageTitle || document.title,
                        path: window.location.href,
                        name,
                        source,
                        event,
                        duration,
                        currentTime,
                        uaId: this._UAId,
                        pid: window.ca("get", "pid"),
                        tagIds: this._tagIds,
                        pageId: this._pageId
                    })
                }
            }
        }
    }
</script>

<style lang="less">
    @import "~@custouch-open/resource-video/vue/dist/style.css";

    .minisite-video-container {
        ul {
            list-style: none;
            padding: 0;
        }
        //videoSrceo {
        //    width: 100%;
        //    //height: 100%;
        //}
    }

    //.c-vjs-w-full {
    //    width: 100%;
    //    height: 400px!important;
    //}
</style>
<style lang="less" scoped>
    .minisite-video-container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        width: 100%;
        max-width: 100%;
        max-height: 100%;

        .minisite-video {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            /*background-repeat: no-repeat;*/
        }

        .video-title {
            position: absolute;
            bottom: 0;
            width: 100%;
        }

        .empty-video {
            font-size: 36px;
            margin: 0 auto;
        }
    }
</style>
